/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

//-------------------------------------------
function findCallbackInArray(callback, callbacks) {
    /// <summary>
    /// Searchs the array for the index of the original function
    /// and the wrapper function.
    /// </summary>
    var i, length;
    // loop through and look for match of the original function
    for (i = 0, length = callbacks.length; i < length; i += 1) {
        if (callbacks[i][0] === callback) { return i; }
    }
    return -1;
}


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// CallbackSubscribable class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function CallbackSubscribable($callback) {
    /// <summary>
    /// Initializes a subscribable which is a wrapper for a
    /// jQuery.Callbacks that hides disable/fire/fired/fireWith/lock/locked
    /// Also add/remove only support a function (not an array of functions).
    /// Addresses issue with IE passing functions between windows
    /// (http://stackoverflow.com/questions/10499623/cant-pass-a-function-from-one-window-to-another-in-ie/10524514#10524514)
    /// </summary>

    // Allow instantiation without the 'new' keyword
    if (!(this instanceof CallbackSubscribable)) { return new CallbackSubscribable($callback); }

    this._$callback = $callback;
    this._callbackMap = []; // map of IE "object-functions" (from another window) to wrapper-function
    return this;

}


//-------------------------------------------
CallbackSubscribable.prototype.add = function subscribableAdd(callback) {
    /// <summary>
    /// Registers a callback if it is not already registered.
    /// An error is thrown if the callback is not a function.
    /// </summary>
    /// <param name="callback">
    /// A function that is to be added to the callback list.
    /// </param>

    if (typeof callback === "function") {
        this._$callback.add(callback);

    // Handle invalid type of function in IE when passed accross windows
    } else if (callback && callback.call) {
        var tempCallback = function handler(data) { callback(data); },
            i = findCallbackInArray(callback, this._callbackMap);
        if (i < 0) {
            this._callbackMap.push([callback, tempCallback]);
            this._$callback.add(tempCallback);
        }

    } else {
        throw new Error("$.Callbacks.Subscribable.add requires a callback function");
    }

    return this;

};


//-------------------------------------------
CallbackSubscribable.prototype.empty = function subscribableEmpty() {
    /// <summary>
    /// Removes all of registered callbacks
    /// </summary>
    this._$callback.empty();
    this._callbackMap.length = 0; // empty the callbacks array -> http://css-tricks.com/snippets/javascript/empty-an-array/
    return this;
};


//-------------------------------------------
CallbackSubscribable.prototype.has = function subscribableHas(callback) {
    /// <summary>
    /// Determine whether the callback is registered
    /// </summary>
    return (typeof callback === "function")
        ? this._$callback.has(callback)
        : (findCallbackInArray(callback, this._callbackMap) >= 0);
};


//-------------------------------------------
CallbackSubscribable.prototype.remove = function subscribableRemove(callback) {
    /// <summary>
    /// Removes a registered callback
    /// </summary>

    if (typeof callback === "function") {
        this._$callback.remove(callback);

    // Handle invalid type of function in IE when passed accross windows
    } else if (callback && callback.call) {
        var i = findCallbackInArray(callback, this._callbackMap);
        if (i >= 0) {
            this._$callback.remove(this._callbackMap[i][1]);
            this._callbackMap.splice(i, 1);
        }
    }

    return this;
};

module.exports = CallbackSubscribable;




//////////////////
// WEBPACK FOOTER
// ./~/pli/clientbroadcastmanager/jquery.callbackSubscribable.js
// module id = 479
// module chunks = 49